import { Component, Input, Output, forwardRef, EventEmitter, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'wl-autocomplete',
  templateUrl: './autocomplete.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true
    },
  ]
})
export class AutocompleteComponent implements ControlValueAccessor {

  @Input() label: string;
  @Input() placeholder: string;
  @Input() required = false;
  @Input() options: any[];
  @Output() selected = new EventEmitter<string>();
  filteredOptions: any[];

  disabled = false;
  private _text: any;
  get text(): any { return this._text; }
  set text(v: any) { this._text = v; this.onChange(v); }

  constructor() {
    this.placeholder = this.label;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.filteredOptions = [...this.options];
    }
  }


  private onChange = (_) => { };

  private onTouched = () => { };

  writeValue(value: any) { this.text = value }

  registerOnChange(fn) { this.onChange = fn }

  registerOnTouched(fn) { this.onTouched = fn }

  setDisabledState(isDisabled) { this.disabled = isDisabled }

  // TODO: filter works only the first time. second time onwards, the list is
  // empty and doesn't update. Create a two-way binding? event emitter?
  // when value changes, the setter is called, somehow update the list
  filterOptions(text: string) {
    if (text) {
      return this.filteredOptions = this.options.filter(s => new RegExp(`^${text}`, 'gi').test(s.name));
      // return this.options = this.options.filter(accomod => accomod.name.toLowerCase().indexOf(text.toLowerCase()) === 0);
    } else {
      this.filteredOptions = this.options;
      return this.filteredOptions;
    }
  }

  check(val) {
    // sessionStorage.setItem("selected",JSON.stringify(val));
    console.log('Selected (core)', val);
    this.selected.emit(val);

  }

}
